import React from 'react';
import { Link } from 'react-router-dom';
import myImg from '../../../images/portfolio.jpg'
import TypeEffect from '../../TypeEffect/TypeEffect'
import './Header.css'


const Header = () => {
    const downLink =`https://drive.google.com/uc?export=download&id=1RxLb0vh5GYOznlmEz9-RqvqvWInjiaxO`;
    
    return (
        <div className="row header-area">
            <div className="col-md-5 p-0 header-img">
                <img className="intro-img ms-0" src={myImg} alt=""/>
            </div>
            <div className="col-md-6 intro-des">
                <h5 className="text-secondary p-2">Web Developer</h5>
                <h2 className="my-name p-2 "> <TypeEffect/> </h2>
                <p className="intro-about mt-3 p-2">I am a Tech Enthusiastic. I believe hard work is the prerequisite of success. I am a software developer and continuous learner. Love to take challenges. Started coding in the very early days of first year in university. Dream to work in google.</p>
                <a id="cv-download" href={downLink}>Download Resume</a>
                <Link id="intro-contact" to="/contact">Contact</Link>
            </div>
            
        </div>
    );
};

export default Header;